import { render, staticRenderFns } from "./IdentiteitResultsHeader.vue?vue&type=template&id=94b690e6&scoped=true&"
import script from "./IdentiteitResultsHeader.vue?vue&type=script&lang=js&"
export * from "./IdentiteitResultsHeader.vue?vue&type=script&lang=js&"
import style0 from "./IdentiteitResultsHeader.vue?vue&type=style&index=0&id=94b690e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b690e6",
  null
  
)

export default component.exports